import React from 'react';

import { flagStyles } from '../settings';

const SvgBS = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-720px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBS;
